import { __values } from "tslib";
import { SchemaDiffUtils, } from '@tencent/memoire-core';
import CollectionBuilder from './builders/collection-builder';
var AutoMonotonicMigration = /** @class */ (function () {
    function AutoMonotonicMigration() {
        this.context = { actions: { schema: [], data: [] }, scope: { database: null, collection: null } };
        this.builder = CollectionBuilder.create(this.context);
    }
    AutoMonotonicMigration.prototype.init = function (state) {
        this.state = state;
        this.build();
    };
    AutoMonotonicMigration.prototype.plan = function () {
        if (!this.context.actions.schema.length && !this.context.actions.data.length)
            return [];
        return [
            {
                schema: {
                    actions: this.context.actions.schema.slice(),
                },
                data: {
                    actions: this.context.actions.data.slice(),
                },
            },
        ];
    };
    AutoMonotonicMigration.prototype.handleDropCollection = function (collections) {
        var e_1, _a;
        try {
            for (var collections_1 = __values(collections), collections_1_1 = collections_1.next(); !collections_1_1.done; collections_1_1 = collections_1.next()) {
                var col = collections_1_1.value;
                this.builder.collection(col.name).drop();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (collections_1_1 && !collections_1_1.done && (_a = collections_1.return)) _a.call(collections_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AutoMonotonicMigration.prototype.handleCreateCollection = function (collections) {
        var e_2, _a;
        var _loop_1 = function (col) {
            this_1.builder
                .collection(col.name)
                .create(col)
                .ensure(function (c) {
                var e_3, _a;
                try {
                    for (var _b = (e_3 = void 0, __values(col.indices)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var index = _c.value;
                        c.index(index.name).create(index);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            });
        };
        var this_1 = this;
        try {
            for (var collections_2 = __values(collections), collections_2_1 = collections_2.next(); !collections_2_1.done; collections_2_1 = collections_2.next()) {
                var col = collections_2_1.value;
                _loop_1(col);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (collections_2_1 && !collections_2_1.done && (_a = collections_2.return)) _a.call(collections_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    AutoMonotonicMigration.prototype.handleIndexChange = function (indexDiffs) {
        var e_4, _a;
        var _loop_2 = function (diff) {
            this_2.builder.collection(diff.collection).ensure(function (c) {
                var e_5, _a, e_6, _b;
                var _c, _d;
                try {
                    for (var _e = (e_5 = void 0, __values(((_c = diff.index) === null || _c === void 0 ? void 0 : _c.added) || [])), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var index = _f.value;
                        c.index(index.name).create(index);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                try {
                    for (var _g = (e_6 = void 0, __values(((_d = diff.index) === null || _d === void 0 ? void 0 : _d.deleted) || [])), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var index = _h.value;
                        c.index(index.name).drop();
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            });
        };
        var this_2 = this;
        try {
            for (var indexDiffs_1 = __values(indexDiffs), indexDiffs_1_1 = indexDiffs_1.next(); !indexDiffs_1_1.done; indexDiffs_1_1 = indexDiffs_1.next()) {
                var diff = indexDiffs_1_1.value;
                _loop_2(diff);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (indexDiffs_1_1 && !indexDiffs_1_1.done && (_a = indexDiffs_1.return)) _a.call(indexDiffs_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    AutoMonotonicMigration.prototype.build = function () {
        if (!this.state) {
            throw new Error('Migration state is undefined, must init before!');
        }
        var _a = this.state.schema, expect = _a.expect, actual = _a.actual;
        var diff = SchemaDiffUtils.databaseDiff(actual, expect);
        this.handleCreateCollection(diff.added);
        this.handleDropCollection(diff.deleted);
        this.handleIndexChange(diff.different);
    };
    return AutoMonotonicMigration;
}());
export { AutoMonotonicMigration };
//# sourceMappingURL=migration.js.map